import axios from "axios"
import ApiConfig from "../config/ApiConfig"

export const addProvider = async(payload) =>{
    const result = axios.post(ApiConfig.addProvider, payload);
    return result
}

export const getCareTeamProvider = async() => {
    const result = axios.get(ApiConfig.getCareTeamProvider)
    return result
}

export const getAllCareTeamMemberList = async(type='') => {
    const result = axios.get(`${ApiConfig.getAllCareTeamMemberList}${type}`)
    return result
}

export const getAllCareTeamGroupProgramsList = async(type='',id = '' ) => {
    const result = axios.get(`${ApiConfig.getAllCareTeamGroupsPrograms}${type}&careTeamId=${id}`)
    return result
}

export const getCareTeams = async() => {
    const result = axios.get(ApiConfig.getCareTeams)
    return result
}
export const getCareTeamsforAdmin = async(id = '') => {
    const result = axios.get(`${ApiConfig.getCareTeamsforAdmin}${id}`)
    return result
}

export const getPatientListCareTeam = async() => {
    const result = axios.get(ApiConfig.getPatientListCareTeam)
    return result
}

export const assignCareTeamtoGroup = async(payload,id) =>{
    const result = axios.post(`${ApiConfig.assignCareTeamtoGroup}${id}`, payload);
    return result
}

export const addCareTeam = async(payload, id='') =>{
    const result = axios.post(`${ApiConfig.addCareTeam}${id ? `?teamId=${id}`: ''}`, payload);
    return result
}

export const deleteCareTeam = async(id) =>{
    const result = axios.delete(`${ApiConfig.deleteCareTeam}${id}`);
    return result
}

export const assignPatientProvider = async(payload)=>{
    const result = axios.post(ApiConfig.assignPatientToProvider, payload)
    return result
}

export const getMemberChartData = async(param)=>{
    const result = axios.get(`${ApiConfig.getMemberChartData}${param}`)
    return result
}

export const getGenderDatabyTeamId = async(year,teamId)=>{
    const result = axios.get(`${ApiConfig.getGenderDatabyTeamId}?year=${year}&careTeamId=${teamId}`)
    return result
}

export const getClientDatabyTeamId = async(year,teamId)=>{
    const result = axios.get(`${ApiConfig.getClientDatabyTeamId}?year=${year}&careTeamId=${teamId}`)
    return result
}
export const getEncounterChartData = async(param)=>{
    const result = axios.get(`${ApiConfig.getEncounterChartData}${param}`)
    return result
}

export const getAllSessionsandEvents = async(type = 'all', id = '')=>{
    const result = axios.get(`${ApiConfig.getAllSessionsandEvents}${type}&careTeamId=${id}`)
    return result
}

export const updateCareTeamRequest = async(payload) => {
    const result =  axios.post(ApiConfig.updateCareTeamRequest, payload)
    return result
}

export const updateCareTeamStatus = async(id) => {
    const result =  axios.post(`${ApiConfig.updateCareTeamStatus}${id}`)
    return result
}

export const updateCareTeamStatusAdmin = async(payload) => {
    const result =  axios.post(`${ApiConfig.updateCareTeamStatusAdmin}`, payload)
    return result
}